module.exports = __webpack_public_path__ + "static/media/tommySleeveHood5.625a1380.svg";